export const scoreMax = 4

export type KeyPasswordFeedback =
  | "commonPassword"
  | "minLength8"
  | "mustContainDigit"
  | "mustContainSpecialCharacter"
  | "mustContainUppercaseLetter"
  | "mustContainLowercaseLetter"

export interface PasswordResponse {
  score: number
  feedback: {
    warning: string
    suggestions: string[]
  }
}
